import React from "react";

/**
 * Replace VIDEO_ID_* with real YouTube IDs
 */
const focusVideos = [
  { id: 1, title: "10 Minute Guided Meditation for Focus", youtubeId: "ausxoXBrmWs" },
  { id: 2, title: "Improve Memory and Focus", youtubeId: "vceXCrOTUe0" },
  { id: 3, title: "5 Minute Meditation for Focus", youtubeId: "zSkFFW--Ma0" },
  { id: 4, title: "Guided Meditation For Powerful Positivity", youtubeId: "-Tb1lR8Z5oM" },
  { id: 5, title: "Intermediate Meditation to Improve Focus", youtubeId: "uZT3cuj_JK4" },
  { id: 6, title: "Advanced Breathing For Maximum Focus", youtubeId: "A_BTySUYvU8" },
];

export default function Focus() {
  return (
    <div className="flex flex-col bg-white min-h-screen">
      <div className="flex flex-grow items-start justify-center px-4 py-8">
        <div className="w-full max-w-6xl">
          <h1 className="text-3xl font-bold mb-6">This Month&apos;s Focus Picks</h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {focusVideos.map((video) => (
              <div
                key={video.id}
                className="bg-white rounded-lg shadow-md border border-gray-200 flex flex-col overflow-hidden"
              >
                <div className="relative w-full pb-[56.25%] bg-gray-100">
                  {video.youtubeId.startsWith("VIDEO_ID") ? (
                    <div className="absolute inset-0 flex items-center justify-center text-gray-400 text-sm">
                      Video coming soon
                    </div>
                  ) : (
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={`https://www.youtube.com/embed/${video.youtubeId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  )}
                </div>

                <button
                  type="button"
                  className="w-full text-left px-4 py-3 border-t border-gray-200 font-semibold hover:text-[#e53935] transition"
                  onClick={() => {
                    if (!video.youtubeId.startsWith("VIDEO_ID")) {
                      window.open(
                        `https://www.youtube.com/watch?v=${video.youtubeId}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }
                  }}
                >
                  {video.title}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
